"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _Free = _interopRequireDefault(require("../Free"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

var BooleanState = function BooleanState(_ref) {
  var children = _ref.children,
      unused = _objectWithoutProperties(_ref, ["children"]);

  return React.createElement(_Free.default, unused, function (_ref2) {
    var state = _ref2.state,
        set = _ref2.set;
    return React.Children.only(children({
      state: state,
      set: function (_set) {
        function set(_x) {
          return _set.apply(this, arguments);
        }

        set.toString = function () {
          return _set.toString();
        };

        return set;
      }(function (val) {
        return set(Boolean(val));
      }),
      toggle: function toggle() {
        return set(!state);
      }
    }));
  });
};

var _default = BooleanState;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/quark-core/components/state/Boolean/index.js
// module id = ./node_modules/quark-core/components/state/Boolean/index.js
// module chunks = 0